import CasesGroup from './CasesGroup';
import ContactsGroup from './ContactsGroup';
import CreditorsGroup from './CreditorsGroup';
import DocumentsGroup from './DocumentsGroup';
import EconomyGroup from './EconomyGroup';
import InteractionsGroup from './InteractionsGroup';
import PaginationGroup from './PaginationGroup';
import PaymentPlansGroup from './PaymentPlansGroup';
import UpdatesGroup from './UpdatesGroup';
import WorkflowsGroup from './WorkflowsGroup';
import PropertiesGroup from './PropertiesGroup';
import { TenantType } from '@debbie/common/dist/tenants';
export default {
    [TenantType.AccountsReceivable]: [
        CasesGroup,
        UpdatesGroup,
        EconomyGroup,
        DocumentsGroup,
        WorkflowsGroup,
        PaymentPlansGroup,
        ContactsGroup,
        InteractionsGroup,
        PropertiesGroup,
        PaginationGroup,
    ],
    [TenantType.Agency]: [
        CreditorsGroup,
        CasesGroup,
        UpdatesGroup,
        EconomyGroup,
        DocumentsGroup,
        WorkflowsGroup,
        PaymentPlansGroup,
        ContactsGroup,
        InteractionsGroup,
        PropertiesGroup,
        PaginationGroup,
    ],
};
//# sourceMappingURL=index.js.map